export default "__VITE_ASSET__Bwer_SuE__"